
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { useRouter, useRoute } from "vue-router";
import useCss from "@/composables/useCss";
import ArticlesLine from "@/components/ArticlesLine.vue";
import Complex from "@/views/articles/learning/Complex.vue";
export default {
  components: { ArticlesLine, Complex },
  setup() {
    const router = useRouter();
    // const ss = useStore().state;
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    const { count, slide, cqueA, cque, devToggle } = useCss();
    // css import

    // const barsDrop = cque(".barsDrop");
   
    

    // const devToggle = () => {
    //   const devs = cqueA(".dev");
    //   devs.forEach(item => {
    //     item.classList.toggle("devNone");
    //   });
    // };

    onMounted(() => {
      //elements
      ////////////////////////////////////
      // const barsDrop = ref(cque(".barsDrop"));
      // console.log(barsDrop.value);
    });
    ////////////////////////
    return {
      // ss, sg
      router,
    };
  }
};
